import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import './FilterChips.scss';

const FilterChips = ({ chips, onRemoveChip }) => {
  if (!chips || chips.length === 0) {
    return null;
  }

  return (
    <div className="filter-chips-container">
      {chips.map((chip) => (
        <div key={chip.key} className="filter-chip"> <button 
            className="filter-chip-remove" 
            onClick={() => onRemoveChip(chip.key)}
            aria-label={`הסר ${chip.text}`}
          >
            <Image src={require('./Icon/removeIcon.svg')} alt="remove" />
          </button>

          <span className="filter-chip-text">{chip.text}</span>

        </div>
      ))}
    </div>
  );
};

export default FilterChips;